import { NormalizedNumber, raise } from '@sparkdotfi/common-universal'

import { EasyBorrowFormNormalizedData } from '../types'
import type { AssetInputSchema, EasyBorrowFormSchema } from './validation'
import { TokenWithBalance, TokenWithValue } from '@/domain/common/types'

export function normalizeFormValues(
  values: EasyBorrowFormSchema,
  formAssets: TokenWithBalance[],
): EasyBorrowFormNormalizedData {
  function normalizeAsset(asset: AssetInputSchema): TokenWithValue {
    const tokenWithBalance = formAssets.find((t) => t.token.symbol === asset.symbol) ?? raise('Asset not found')
    return {
      token: tokenWithBalance.token,
      value: NormalizedNumber(asset.value === '' ? '0' : asset.value),
    }
  }

  return {
    borrows: values.assetsToBorrow.map(normalizeAsset),
    deposits: values.assetsToDeposit.map(normalizeAsset),
  }
}
